module.exports = __webpack_public_path__ + "img/mobile.70e059ad.webp";